webpackJsonp([1],{

/***/ 152:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/*
	Компілюється у файл
*/
 true ? console.log('Production mode!') : require('__page/index.html');

/*
	Підключаєм конструктор модулів
*/
var mc = __webpack_require__(6);

var ScrollDetective = __webpack_require__(7);

var sd = new ScrollDetective({
	onVisible: function onVisible(el) {
		el.classList.add('complete');
	}
});

sd.addBlocks(".top_laptop");
sd.addBlocks(".fourBlocks ul li");
sd.addBlocks("#setcion-3 .row .cols .block");
sd.addBlocks("#setcion-4");
sd.checkStates();
sd.addScrollEvent();

/**
	Запускаєм конструктор модулів. Аргументом приймає масив назв vue-компонентів,
	які треба включити в процес збірки проекту.
	@type {Array<String>}
*/
mc(['Slider']);

/*
	Запускаєм скріпти html компонентів
*/
STACK.forEach(function (f) {
	f($);
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ })

},[152]);


// WEBPACK FOOTER //
// bundles/detail.bundle.js